module.exports = __webpack_public_path__ + "static/img/全景运展云.77f641ea.png";